'use client'
import React, { FC } from 'react'
import Heading from '../../commercetools-ui/atoms/heading'
import PremiumsSection from '../../commercetools-ui/molecules/premiums-section'

interface ContentstackLoyaltyPremiumsSectionProps {
  heading?: string
  premiums_category?: string
}

const ContentstackLoyaltyPremiumsSection: FC<ContentstackLoyaltyPremiumsSectionProps> = ({
  heading,
  premiums_category,
}) => (
  <section>
    <div className='relative mx-auto mb-48 max-h-full max-w-screen-xl px-16 md:mb-64 md:px-24 lg:px-20 xl:px-48'>
      {heading &&
        <Heading level={2} className='mb-25'>
          {heading}
        </Heading>
      }
      <PremiumsSection category={premiums_category} />
    </div>
  </section>
)

export default ContentstackLoyaltyPremiumsSection
